module.exports = __WEBPACK_EXTERNAL_MODULE__12244__;